export const API_URL ={
    development:"https://myprotour.com/api",
    production: "https://myprotour.com/api"
  }

export const API_URL2 = {
    development: "https://myprotour.com/api/hotel/",
    production: "https://myprotour.com/api/hotel/",
  };

export const API_URL_IMAGE ={
  development:"https://myprotour.com/",
  production: "https://myprotour.com/"
}

export const API_URL_IMAGE2 ={
  development:"https://myprotour.com/hotel/",
  production: "https://myprotour.com/hotel/"
}

// Resolve image URL — handles both absolute (https://...) and relative paths
export const resolveImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return API_URL_IMAGE[process.env.NODE_ENV] + url;
};

export const resolveImageUrl2 = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return API_URL_IMAGE2[process.env.NODE_ENV] + url;
};
